import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UnitMeasureService } from './../../services/unit-measure.service';

@Component({
    selector: 'app-cfg-phase-dialog',
    templateUrl: './cfg-phase-dialog.component.html',
    styleUrls: ['./cfg-phase-dialog.component.scss']
})
export class CfgPhaseDialogComponent implements OnInit {
    @Input() phaseData: any;
    @Output() close = new EventEmitter<void>();
    @Output() save = new EventEmitter<any>();

    unitMeasures: any[] = [];

    constructor(private unitMeasureService: UnitMeasureService) { }

    originalData: any;

    ngOnInit(): void {
        this.originalData = JSON.parse(JSON.stringify(this.phaseData)); // o macroPhaseData
        this.loadUnitMeasures?.(); // solo in phase
    }

    loadUnitMeasures(): void {
        this.unitMeasureService.getAllUnitMeasures().subscribe({
            next: (res) => {
                this.unitMeasures = res;
            },
            error: (err) => {
                console.error('Errore nel recupero delle unità di misura', err);
            }
        });
    }

    onSave() {
        if (this.isFormValid()) {
            this.save.emit(this.phaseData);
        }
    }

    onClose() {
        this.close.emit();
    }

    isFormValid(): boolean {
        return (
            this.phaseData?.name?.trim() &&
            this.phaseData?.qProdOraria != null &&
            this.phaseData?.cMater != null &&
            this.phaseData?.position != null
        );
    }
    isUnchanged(): boolean {
        return JSON.stringify(this.phaseData) === JSON.stringify(this.originalData); // o macroPhaseData
    }

}
